import { FC } from 'react';

import { FileIconVariant } from '../../../assets/icons/file-icon';
import { FileIcon } from '../../../assets/icons/index';
import { AppFormattedMessage } from '../../../components/app-formatted-message/index';
import { Tooltip } from '../../../components/tooltip/index';
import { VaultFile, VaultFileSource } from '../../../types/vault.types';

export const isVaultDocusignFile = (file: Pick<VaultFile, 'fileSource' | 'signatureId'>): boolean =>
  file.fileSource === VaultFileSource.DOCUSIGN || Boolean(file.signatureId);

type VaultFileIconProps = {
  className?: string;
  file: Pick<VaultFile, 'fileSource' | 'signatureId'>;
};

export const VaultFileIcon: FC<VaultFileIconProps> = ({ className, file }) => {
  const isDocusignFile = isVaultDocusignFile(file);
  const variant = isDocusignFile ? FileIconVariant.DOCUSIGN : FileIconVariant.FILLED;
  const icon = <FileIcon className={className} variant={variant} />;

  if (!isDocusignFile) {
    return icon;
  }

  return (
    <Tooltip content={<AppFormattedMessage id="DOCUSIGN_VAULT_FILE_TOOLTIP" />}>{icon}</Tooltip>
  );
};
